import { Component, Input, OnInit } from '@angular/core';
import { JsonSchemaFormService } from '@ajsf/core';
import { EETextBoxLayoutNode, EETextBoxOptions } from './ee-widget-options.model';
import { JsfUtilsService } from '@xm-ngx/ext/ee-core-webapp-ext/jsf-module/jsf-utils.service';

@Component({
  selector: 'xm-text-box',
  standalone: false,
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.scss']
})
export class TextBoxComponent implements OnInit {

  @Input() public layoutNode: EETextBoxLayoutNode;

  public options: Partial<EETextBoxOptions>;
  public controlValue: string;

    public defaultValidationMessages: {[key: string]: string} =
        this.utils.getDefaultValidationMessages();

  constructor(
    private jsf: JsonSchemaFormService,
    protected utils: JsfUtilsService,
  ) { }

  ngOnInit(): void {
    this.options = this.layoutNode && this.layoutNode.options || {};
    this.jsf.initializeControl(this);
  }

  changeText($event) {
    this.jsf.updateValue(this, $event.target.value);
  }

}
